<div class="products-page">
  <div class="grid">
    <div class="col-3" *ngIf="!isCategoryPage">
      <h4>Categories</h4>
      <div class="field-checkbox" *ngFor="let category of categories">
        <p-checkbox
          [(ngModel)]="category.checked"
          [binary]="true"
          [inputId]="category"
          (onChange)="categoryFilter()"
        ></p-checkbox>
        <label for="{{ category.id }}">{{ category.name }}</label>
      </div>
    </div>
    <div [ngClass]="{ 'col-9': !isCategoryPage, 'col-12': isCategoryPage }">
      <div class="grid" *ngIf="products">
        <div
          [ngClass]="{ 'col-4': !isCategoryPage, 'col-3': isCategoryPage }"
          *ngFor="let product of products"
        >
          <products-product-item [product]="product"></products-product-item>
        </div>
      </div>
    </div>
  </div>
</div>
